// src/modules/app-views/goodsReceipt/components/CardHeaderGoodsReceiptNumberDateTotal.jsx
// *******************************************************************************
// CARD HEADER COLUMN 1: Document Number, Issue Date, Total Amount
// *******************************************************************************
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { NumberOutlined, CalendarOutlined, DollarOutlined } from '@ant-design/icons';
import { parseDateToDisplay } from 'utils/helpers';
import translateX from 'utils/translateX';
import financialService from 'services/financialService';
import appService from 'services/appService';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const CardHeaderGoodsReceiptNumberDateTotal = ({
  showItem1 = true,
  showItem2 = true,
  showItem3 = true,
  forceShow = false,
  ...record
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  // Document number (number - serie format)
  const serie = record?.documentSerie || 1;
  const docNumber = record?.documentNumber;
  const displayNumber = docNumber ? `${docNumber}-${serie}` : null;

  // Issue date
  const issuedAt =
    record?.issueDate && parseDateToDisplay({ date: record?.issueDate, showHours: false });

  // Document total
  const documentTotal = record?.totals?.documentAmount;

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'documentNumber',
      icon: <NumberOutlined />,
      label: displayNumber || <span className="text-muted opacity-0-6">N/D</span>,
      tooltipText: translateX('document_number'),
      tooltipPlacement: 'right',
      onClick: record?.accessKey
        ? () => appService.handleCopyToClipboard(record.accessKey, 'fiscal_key_copied')
        : null,
      hidden: !showItem1,
    },
    {
      key: 'issueDate',
      icon: <CalendarOutlined />,
      label: issuedAt || <span className="text-muted opacity-0-6">N/D</span>,
      tooltipText: translateX('issue_date'),
      tooltipPlacement: 'right',
      onClick: null,
      hidden: !showItem2,
    },
    {
      key: 'documentTotal',
      icon: <DollarOutlined />,
      label:
        documentTotal !== undefined && documentTotal !== null ? (
          <strong>{financialService.formatCurrency(documentTotal)}</strong>
        ) : (
          <span className="text-muted opacity-0-6">N/D</span>
        ),
      tooltipText: translateX('total_value'),
      tooltipPlacement: 'right',
      onClick: null,
      hidden: !showItem3,
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items?.filter(i => (i?.label || forceShow) && !i.hidden)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderGoodsReceiptNumberDateTotal;
